import { OEText } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';

import { PortalPaths } from '../../interfaces/portal-paths.enum';
import { PortalLayout } from '../../templates/portal-layout/portal-layout';

export interface ClassroomPageProps {
  message: string;
}

export const ClassroomPage = ({ message }: ClassroomPageProps) => {
  return (
    <PortalLayout selectedPage={PortalPaths.Dashboard} title="Dashboard">
      <Container>
        <OEText fontSize={32} lineHeight={32} fontType="bold">
          {message}
        </OEText>
      </Container>
    </PortalLayout>
  );
};

const Container = styled.View`
  gap: 32px;
  padding-bottom: 32px;
`;
